// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 726) return "static/chunks/726-816bc71a010c43d0.js";
	if (chunkId === 572) return "static/chunks/572-654f19630841e640.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"434":"da537d689fd51869","875":"b23efcef22aa23d3","878":"85079017cc473e6b"}[chunkId] + ".js";
};